import ConsentModel from './consent';
import { setCookie } from '../util/storage';
export default class ConsentModModel extends ConsentModel {
    async save(origin) {
        const response = await this.send(origin);
        const { euconsent, usprivacy, uuid } = await response.json();
        const consentStr = euconsent || usprivacy;
        this.updateStorage(consentStr, uuid);
        setCookie(ConsentModel.getCookieName(), consentStr, this.getCookieExpireDays(this.consented));
        setCookie('uuid', uuid, 100 * 365);
        this.load();
        this.emit('update');
    }
}
